export default function checkSettings(key) {
    let valid_keys = {
        hide_model_number: 1,
        hide_standard_pricing: 1,
        show_quote_list_price: 1,
        send_room_titles_to_trend: 1
    };
    if(!valid_keys[key]) return false;
    return parseInt(localStorage.getItem(key));
}

export function saveSettings(settings) {
    localStorage.setItem("hide_model_number", settings.hide_model_number);
    localStorage.setItem("hide_standard_pricing", settings.hide_standard_pricing);
    localStorage.setItem("show_quote_list_price", settings.show_quote_list_price);
    localStorage.setItem("send_room_titles_to_trend", settings.send_room_titles_to_trend);
}
